import React from "react";
import { styled } from "styled-components";
import { Title } from "./shared/Title";
import { Subtitle } from "./shared/Subtitle";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
// import firstImage from "./first-months.png";
// import secondImage from "./last-month.png";
import { theme } from "../theme";

const WrapperStyled = styled.div`
  margin: 70px 15%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MonthWrapper = styled.div`
  display: flex;
`;

const ListStyled = styled.ul`
  font-style: italic;
  margin-right: 50px;
  list-style: none;
  padding-left: 0;

  & li {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  & svg {
    margin-right: 10px;
  }
`;

export const Timeline = () => {
  return <></>
//   return (
//     <WrapperStyled>
//       <Subtitle>Formación 100% enfocada en la inserción laboral</Subtitle>
//       <Title>A programar se aprende programando</Title>
//       <p style={{ width: "60%" }}>
//         En solo 6 meses habrás adquirido destreza suficiente en las tecnologías
//         más demandadas en desarrollo web frontend y te habrás enfrentado a las
//         dinámicas habituales de un equipo profesional de desarrolladores.
//       </p>
//       {/* TODO: Add timeline element here */}
//       <MonthWrapper>
//         <div>
//           <Subtitle text="Meses 1-5" color="blue" />
//           <Title text="Clases online en vivo" />
//           <p>
//             Aprende con nuestros profesores en dinámicas y participativas clases
//             online en directo. El docente compartirá pantalla con sus alumnos
//             para ir resolviendo y explicando ejercicios prácticos relacionados
//             con la materia.
//           </p>
//           <ListStyled>
//             <li>
//               <PlayArrowOutlinedIcon sx={{ color: theme.colors.blue }} />
//               Te enseñamos a aprovechar los últimos avances en IA para escribir
//               código de forma más eficiente.
//             </li>
//             <li>
//               <PlayArrowOutlinedIcon sx={{ color: theme.colors.blue }} />
//               Disfrutarás de actividades y juegos grupales para profundizar en
//               la materia.
//             </li>
//             <li>
//               <PlayArrowOutlinedIcon sx={{ color: theme.colors.blue }} />
//               Deberás resolver ejercicios y cuestionarios para poner en práctica
//               lo aprendido.
//             </li>
//           </ListStyled>
//         </div>
//         <img src={firstImage} style={{ height: "100%" }} />
//       </MonthWrapper>
//       <MonthWrapper>
//         <img
//           src=""//{secondImage}
//           style={{ height: "100%", marginRight: "40px" }}
//         />
//         <div>
//           <Subtitle text="Mes 6" />
//           <Title text="Proyecto final grupal" />
//           <p>
//             En tu futuro empleo no trabajarás solo, sino que te integrarás en un
//             equipo multidisciplinar formado por frontenders, backenders, UX UI
//             designers, scrum master, product owner...{" "}
//           </p>
//           <p>
//             Por eso apostamos por un proyecto final grupal en el que te tendrás
//             que coordinar con tus compañeros para terminar un producto final de
//             calidad.
//           </p>
//           <ListStyled>
//             <li>
//               <PlayArrowOutlinedIcon sx={{ color: theme.colors.orange }} />
//               Te enseñamos a aprovechar los últimos avances en IA para escribir
//               código de forma más eficiente.
//             </li>
//             <li>
//               <PlayArrowOutlinedIcon sx={{ color: theme.colors.orange }} />
//               Disfrutarás de actividades y juegos grupales para profundizar en
//               la materia.
//             </li>
//             <li>
//               <PlayArrowOutlinedIcon sx={{ color: theme.colors.orange }} />
//               Deberás resolver ejercicios y cuestionarios para poner en práctica
//               lo aprendido.
//             </li>
//           </ListStyled>
//         </div>
//       </MonthWrapper>
//     </WrapperStyled>
//   );
};
